import httpService from "app/services/httpService";
import config from "../../../src/config.json";

const apiUrl = config.apiUrl;

const getBookingHistory = async (query) => {
  const url = `${apiUrl}/flight/book-flight-all${query ? `?${query}` : ""}`;
  const data = await httpService.get(url);
  return data;
};

const bookingDetails = async (id) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/flight/booking-details/${id}`,
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};
const updatePnr = async (value) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/flight/update-pending-booking-status`,
      value,
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};
const getAirline = async (id) => {
  const {
    data: { data },
  } = await httpService.get(`${apiUrl}/flightcarrier/get-filght-carrier/${id}`);
  return data;
};
const getAirport = async (id) => {
  const {
    data: { data },
  } = await httpService.get(`${apiUrl}/airports/get-airport/${id}`);
  return data;
};
const offlineTicket = async (value) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/flight/offline-ticket-booking`,
      value,
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};
const getAirportTimeZone = async (values) => {
  const {
    data: { data },
  } = await httpService.get(
    `${apiUrl}/flight/get-airport-timezone?searchText=${values}`,
  );
  return data;
};
const editBookingDetails = async (values) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/flight/update-pnr-with-ancillary-amount`,
      values,
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};
const duplicatePaxCheck = async (values) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/flight/check-pnr-on-booking`,
      values,
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};

export {
  duplicatePaxCheck,
  editBookingDetails,
  getAirportTimeZone,
  getBookingHistory,
  bookingDetails,
  updatePnr,
  getAirline,
  getAirport,
  offlineTicket,
};
